import React from 'react'
import { Create } from 'react-admin'

import BroadcastForm from './form'

const BroadcasterTitle = ({ record }) => <span>Nueva difusión:</span>

export const BroadcastCreate = (props) => (
  <Create title={<BroadcasterTitle />} {...props}>
    <BroadcastForm {...props} />
  </Create>
)

export default BroadcastCreate
